/**
 * The values here must match the values in Fiesta.
 */

// TODO: check admin namechange to manager:
export const OPTIMIZER_APP_CONFIG = {
  name: 'admin',
  widths: [50, 100, 500, 800, 1000],
  heights: [],
}

export const OPTIMIZER_SOURCE_CONFIG = [
  {
    name: 'webcontent',
    baseUrl: 'https://webcontent.attensi.com',
  },
  {
    name: 's3-portal-production',
    baseUrl: 'https://attensi-portal-production.s3.eu-central-1.amazonaws.com',
  },
  {
    name: 'backend',
    baseUrl: 'https://backend.attensi.com',
  },
  {
    name: 'api',
    baseUrl: 'https://api.attensi.com',
  },
  {
    name: 'api-staging',
    baseUrl: 'https://api-staging.attensi.com',
  },
]
